import { Checkbox, Form } from "antd";
import React from "react";
import DynamicInputFields from "../../../../../blocks/FormItems/DynamicInputFields";
import { riskFactorOptions } from "../../../../IpEMR/Options/dietAdviceOptions";

const NutritionalRiskFactors = () => {
  const form = Form.useFormInstance();
  const showOthers = Form.useWatch("nutritional_risk_factors")?.includes(
    "others"
  );
  return (
    <>
      <Form.Item
        label="Continued Existence Of The Nutritional Risk Factors"
        name={"nutritional_risk_factors"}
      >
        <Checkbox.Group options={riskFactorOptions} />
      </Form.Item>
      {showOthers && (
        <DynamicInputFields
          field_key={"nutritional_risk_factors_others"}
          form={form}
          inputStyle={{ maxWidth: 800 }}
        />
      )}
    </>
  );
};

export default NutritionalRiskFactors;
